'use strict';

export default class contactCtrl {
  static get UID() {
    return 'contactCtrl';
  }

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./~/site_core/src/features/contact/contactCtrl.js